import * as React from 'react';
import type { SvgProps } from 'react-native-svg';
import { SvgXml } from 'react-native-svg';

const xml = `
  <svg width="14" height="22" viewBox="0 0 14 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path id="&#244;&#128;&#134;&#137;" d="M0.677032 10.9938C0.677032 10.7785 0.7143 10.5797 0.788834 10.3975C0.871649 10.2153 0.995873 10.0414 1.1615 9.87578L10.8385 0.409938C11.1201 0.136646 11.4596 0 11.8572 0C12.1304 0 12.3748 0.0662526 12.5901 0.198758C12.8137 0.322981 12.9917 0.492754 13.1242 0.708075C13.2567 0.923395 13.323 1.1677 13.323 1.44099C13.323 1.83023 13.1698 2.17805 12.8634 2.48447L4.14287 10.9938L12.8634 19.5031C13.1698 19.8095 13.323 20.1615 13.323 20.559C13.323 20.824 13.2567 21.0642 13.1242 21.2795C12.9917 21.5031 12.8137 21.677 12.5901 21.8012C12.3748 21.9337 12.1304 22 11.8572 22C11.4596 22 11.1201 21.8592 10.8385 21.5776L1.1615 12.1118C0.995873 11.9462 0.871649 11.7723 0.788834 11.5901C0.7143 11.4079 0.677032 11.2091 0.677032 10.9938Z"/>
</svg>
`;

export const ChevronLeft = (props: SvgProps) => (
  <SvgXml xml={xml} width="100%" height="100%" {...props} />
);
